module.exports = __webpack_public_path__ + "static/media/cms-logo.cf08d1f3.png";